import { BadgeWithDot } from "@/components/ui/badge"
import type { UserModerationStatus } from "@/types"

type StatusColor = "gray" | "blue" | "warning" | "success" | "error"

// Moderation statuses, mapped to badge colours. "Shell" is an unclaimed
// warm-start account — real row, no human behind it yet.
const STATUS_COLORS: Record<UserModerationStatus, StatusColor> = {
  active: "success",
  shell: "gray",
  suspended: "warning",
  deleted: "error",
}

export function UserStatusBadge({ status }: { status: UserModerationStatus }) {
  return (
    <BadgeWithDot
      color={STATUS_COLORS[status] ?? "gray"}
      size="sm"
      type="modern"
      className="capitalize"
    >
      {status}
    </BadgeWithDot>
  )
}
